export function usePagination(totalCount, { page, pageSize, visiblePages, setPage } = {}) {
    const pagination = getPaginationParams(totalCount, { page, pageSize, visiblePages })

    /** Verifica si hay una página siguiente. */
    const hasNextPage = () => {
        return pagination.page < pagination.totalPages
    }
    /** Cambia a la página siguiente. */
    const goNextPage = () => {
        setPage?.(pagination.page + 1)
    }
    /** Cambia a la última página. */
    const goLastPage = () => {
        if (hasNextPage()) {
            setPage?.(pagination.totalPages)
        }
    }

    /** Verifica si hay una página anterior. */
    const hasPreviousPage = () => {
        return pagination.page > 1
    }
    /** Cambia a la página anterior. */
    const goPreviousPage = () => {
        setPage?.(pagination.page - 1)
    }
    /** Cambia a la primera página. */
    const goFistPage = () => {
        if (hasPreviousPage()) {
            setPage?.(1)
        }
    }

    return {
        ...pagination,
        hasNextPage,
        goNextPage,
        goLastPage,
        hasPreviousPage,
        goPreviousPage,
        goFistPage,
    }
}
export function getPaginationParams(totalItems, initialParams = {}) {
    const page = initialParams.page && initialParams.page > 0 ? initialParams.page : 1
    const pageSize =
        initialParams.pageSize && initialParams.pageSize > 0 ? initialParams.pageSize : 10
    const visiblePages =
        initialParams.visiblePages && initialParams.visiblePages >= 0
            ? initialParams.visiblePages
            : 0
    const totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 1
    const limit = pageSize
    const offset = (page - 1) * pageSize

    let firstVisiblePage = 0
    let lastVisiblePage = 0
    if (visiblePages > 0) {
        const radix = Math.floor(visiblePages / 2)
        if (page - radix > 0) {
            if (page + radix <= totalPages) {
                firstVisiblePage = page - radix
                lastVisiblePage = page + radix
            } else {
                firstVisiblePage = totalPages - visiblePages + 1 || 1
                lastVisiblePage = totalPages
            }
        } else {
            firstVisiblePage = 1
            lastVisiblePage = visiblePages <= totalPages ? visiblePages : totalPages
        }
    }
    const pages =
        visiblePages > 0
            ? Array.from(
                  { length: lastVisiblePage - firstVisiblePage + 1 },
                  (_, i) => firstVisiblePage + i,
              )
            : []
    return { page, pageSize, totalPages, totalItems, limit, offset, pages }
}
